export const isLoggedIn = () => {
  // const hasToken = localStorage.getItem('modeler_token')
  // const email = localStorage.getItem('modeler_email') // commenting out for now to connect with instalimb-one
  const accessToken = getCookie("instalimb_token");
  return Boolean(accessToken);
};

export const logoutHelper = (navigate) => {
  localStorage.clear();
  const domain = isDevMode() ? "localhost" : ".instalimb.com";
  document.cookie = `instalimb_token=; Path=/; Domain=${domain} ; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  navigate("/login");
};

export const isAdminUser = () => {
  return localStorage.getItem("modeler_role") === "admin";
};

export function getCookie(name) {
  let cookieValue;
  if (document.cookie && document.cookie !== "") {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const isDevMode = () => {
  return process.env.NODE_ENV === "development";
};
